import { render, staticRenderFns } from "./OrderPaymentButton.vue?vue&type=template&id=4f790b86&scoped=true&"
import script from "./OrderPaymentButton.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f790b86",
  null
  
)

export default component.exports